var _defs, _path, _g, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMp4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 270,
  height: 155
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "mp4_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h120v119.999H0z",
  "data-name": "Rectangle 130"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f5f5f5",
  d: "M0 0h270v155H0z",
  "data-name": "Rectangle 125"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 238"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#mp4_svg__a)",
  "data-name": "Group 237",
  transform: "translate(75.503 18)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M119.504 59.996A59.5 59.5 0 1 1 60.001.496a59.5 59.5 0 0 1 59.5 59.5",
  "data-name": "Path 2880"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bcc1c9",
  d: "M60.001 120.003a59.73 59.73 0 0 1-33.55-10.248 60.18 60.18 0 0 1-21.74-26.4 59.92 59.92 0 0 1 5.532-56.905 60.2 60.2 0 0 1 26.4-21.739 59.93 59.93 0 0 1 56.906 5.532 60.18 60.18 0 0 1 21.739 26.4 59.93 59.93 0 0 1-5.532 56.905 60.18 60.18 0 0 1-26.4 21.739 59.6 59.6 0 0 1-23.355 4.716m0-119.007a58.73 58.73 0 0 0-32.99 10.076A59.18 59.18 0 0 0 5.633 37.033a58.92 58.92 0 0 0 5.44 55.956 59.2 59.2 0 0 0 25.961 21.378 58.93 58.93 0 0 0 55.957-5.44 59.18 59.18 0 0 0 21.378-25.96 58.93 58.93 0 0 0-5.44-55.956A59.18 59.18 0 0 0 82.968 5.633 58.6 58.6 0 0 0 60.001.996",
  "data-name": "Path 2881"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#353c3c",
  d: "M76.926 87.936H36.957a5.01 5.01 0 0 1-4.9-4.9V43.07h1.7v39.936a3.31 3.31 0 0 0 3.227 3.227h39.938Zm6.1-8.121h-.01l-37.938-.007a5.01 5.01 0 0 1-4.9-4.9V36.96a5.01 5.01 0 0 1 4.9-4.9h37.963a5.01 5.01 0 0 1 4.9 4.9v37.958a5.01 5.01 0 0 1-4.9 4.9Zm-37.913-1.708 37.9.007a3.31 3.31 0 0 0 3.227-3.227v-37.9a3.31 3.31 0 0 0-3.227-3.227h-37.9a3.31 3.31 0 0 0-3.227 3.227V74.88a3.31 3.31 0 0 0 3.227 3.227",
  "data-name": "Path 2882"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#62061f",
  d: "M57.727 66.91a2.2 2.2 0 0 1-1.119-.3 2.32 2.32 0 0 1-1.251-2.151V47.428a2.32 2.32 0 0 1 1.251-2.151 2.21 2.21 0 0 1 2.46.149l13.225 8.5a2.338 2.338 0 0 1 0 4.021l-13.225 8.51a2.22 2.22 0 0 1-1.341.453m0-20.237a.5.5 0 0 0-.265.074q-.031.019-.063.035a.62.62 0 0 0-.343.586v17.147a.62.62 0 0 0 .343.586q.032.016.063.035a.51.51 0 0 0 .584-.037 1 1 0 0 1 .071-.051l13.271-8.54.033-.02a.638.638 0 0 0 0-1.1l-.032-.02-13.272-8.532a1 1 0 0 1-.071-.051.5.5 0 0 0-.319-.112",
  "data-name": "Path 2883"
})))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#004165",
  d: "M196 0h74v31h-74z",
  "data-name": "Rectangle 18374"
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  fill: "#fff",
  fontFamily: "Lato-Bold, Lato",
  fontSize: 14,
  fontWeight: 700,
  transform: "translate(233 21)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -14.945,
  y: 0
}, "MP4"))));
export { SvgMp4 as ReactComponent };
export default __webpack_public_path__ + "40d4b93d21a14e6a84ff3b38f9a5f0a0.svg";